<template>
  <div class="full">
    <div class="full flex flex-col justify-start items-center">
      <router-link v-if="!nologo" to="/">
        <div class="w-full max-w-xs mt-16 mb-8 text-orange-600 font-bold text-2xl text-center">
          PeopleLinking.com
        </div>
      </router-link>

      <div class="w-full max-w-xs">
        <form class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="username">
              Username
            </label>
            <input autocomplete="username" v-model="username" @input="onUsername" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" type="text" placeholder="Username">
            <p v-if="!unique" class=" text-red-400 pt-3">
              Username {{ username }} is taken.
            </p>
          </div>
          <div class="mb-6">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
              Password
            </label>
            <input autocomplete="current-password" v-model="password" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline" :class="{ 'border-red-500': error }" id="password" type="password" placeholder="*********">
            <p v-if="error" class="text-red-500 text-xs italic">Please choose a password.</p>

            <p v-if="errMsg" class="text-red-500">{{ errMsg }}</p>
          </div>

          <div class="flex items-center justify-between">
            <button @click="onRegister"  class="bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button">
              Register
            </button>
            <router-link class="inline-block align-baseline font-bold text-sm text-orange-500 hover:text-orange-800" to="/login">
              Login?
            </router-link>
          </div>

        </form>
        <p class="text-center text-gray-500 text-xs">
          &copy;2019 PeopleLinking.com All rights reserved.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from '../api/api'
export default {
  props: {
    nologo: {
      default: false
    }
  },
  data () {
    return {
      unique: true,
      username: '',
      password: '',
      error: false,
      errMsg: false
    }
  },
  methods: {
    async onUsername () {
      let { unique } = await API.checkUniqueUsername({ username: this.username })
      this.unique = unique
    },
    async onRegister () {
      this.errMsg = false
      if (this.unique && this.password && this.username) {
        try {
          let info = await API.register({ username: this.username, password: this.password })
          API.rememberMe({ profile: { user: info.user, jwt: info.jwt } })
          // this.$router.push('/home')
          this.$router.push('/app/home')
        } catch (e) {
          if (e && e.response && e.response.data && e.response.data.error) {
            console.log(e.response.data.error)
            this.errMsg = e.response.data.error
          }
          // console.log(e.message, e.response.data.error)
        }
      }
    }
  }
}
</script>

<style>

</style>
